import * as React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

interface QueryCacheProviderProps {
  children: React.ReactChild;
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, useErrorBoundary: true } },
});

export const QueryCacheProvider = ({ children }: QueryCacheProviderProps): JSX.Element => (
  <QueryClientProvider client={queryClient}>
    {process.env.NODE_ENV !== 'test' && <ReactQueryDevtools />}
    {children}
  </QueryClientProvider>
);
